import { Box, Typography, useTheme } from "@mui/material";

import { CustomAccordion } from "../customAccordion";

interface Props {
  description: JSX.Element;
  icon: string;
  title: string;
  dataTestId?: string;
}

export function ElementAccordionItem({
  icon,
  title,
  description,
  dataTestId,
}: Props) {
  const theme = useTheme();

  return (
    <CustomAccordion
      dataTestId="personalized-plan-item"
      content={
        <Typography
          sx={(theme) => ({
            color: theme.palette.info.main,
          })}
          variant="body2">
          {description}
        </Typography>
      }
      header={(isExpanded: boolean) => (
        <>
          <Box
            display="flex"
            justifyContent="center"
            sx={(theme) => ({
              width: theme.spacing(8),
              paddingY: theme.spacing(2),
            })}>
            <img
              src={icon}
              alt={title}
              style={{
                maxWidth: theme.spacing(8),
                height: theme.spacing(8),
              }}
            />
          </Box>
          <Typography
            sx={(theme) => ({
              alignItems: "center",
              display: "flex",
              paddingLeft: theme.spacing(2),
            })}
            color={isExpanded ? "secondary" : "inherit"}
            data-testid={dataTestId}>
            {title}
          </Typography>
        </>
      )}
    />
  );
}
